import { VBtn, VSnackbar } from "vuetify/lib";

export default {
	name: "KToasts",

	computed: {
		toast() {
			return this.$store.state.toasts.toast;
		},

		visible: {
			get() {
				return this.toast.visible;
			},

			set( val ) {
				if ( val ) {
					this.$store.commit( "toasts/SHOW", this.toast );
				} else {
					this.remove();
				}
			}
		}
	},

	methods: {
		remove() {
			this.$store.commit( "toasts/REMOVE" );
		}
	},

	render() {
		return <VSnackbar
			color={this.toast.color}
			timeout={this.toast.timeout}
			top
			vModel={this.visible}
			scopedSlots={{
				action: () =>
					<VBtn
						dark
						onClick={this.remove}
						text
					>Close</VBtn>
			}}
		>
			{this.toast.text}
		</VSnackbar>;
	}
};
